"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsEntityChanged = void 0;
const react_1 = require("react");
const use_history_changes_hook_1 = require("./use-history-changes.hook");
const store_1 = require("../../store");
const useIsEntityChanged = () => {
    const { selectedStrategyNodeChanges } = (0, use_history_changes_hook_1.useHistoryChanges)();
    const uniqueEntityPaths = (0, react_1.useMemo)(() => {
        const uniquePaths = new Set();
        selectedStrategyNodeChanges.forEach(({ id }) => {
            const [label, value] = id.split(store_1.LABEL_VALUE_PAIR_SEPARATOR);
            uniquePaths.add(label);
            if (value) {
                uniquePaths.add(id);
            }
        });
        return uniquePaths;
    }, [selectedStrategyNodeChanges]);
    const checkIsAttributeChanged = (0, react_1.useCallback)((label) => uniqueEntityPaths.has(label), [uniqueEntityPaths]);
    const checkIsValueChanged = (0, react_1.useCallback)((label, value) => uniqueEntityPaths.has(`${label}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${value}`), [uniqueEntityPaths]);
    return {
        checkIsAttributeChanged,
        checkIsValueChanged,
    };
};
exports.useIsEntityChanged = useIsEntityChanged;
